/**
* Timeline JS
* -----------------------------------------------------------------------------
*
* All the JS for the Timeline component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
// import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'timeline',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.timeline__group' ).each( function( key, group ) {
        const index = $( this ).index();
        const bar = $( '.timeline__progress' ).find( '.timeline__progress-line' ).eq( index );
        const progressTitle = $( '.timeline__group-title' );
        const thisGroupTitle = $( this ).attr( 'data-title' );
        const isFirstGroup = $( group ).index() === 0;
        const isLastGroup = $( group ).index() === $( '.timeline__group' ).length - 1;

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 50%',
            end: 'bottom 50%',
            scrub: 0,
            onEnter: ( {progress, direction, isActive} ) => {
              $( bar ).addClass( 'is-active' );
              $( progressTitle ).text( thisGroupTitle );
            },
            onLeave: ( {progress, direction, isActive} ) => {
              if ( !isLastGroup ) {
                $( bar ).removeClass( 'is-active' );
              }
            },
            onEnterBack: ( {progress, direction, isActive} ) => {
              $( bar ).addClass( 'is-active' );
              $( progressTitle ).text( thisGroupTitle );
            },
            onLeaveBack: ( {progress, direction, isActive} ) => {
              if ( !isFirstGroup ) {
                $( bar ).removeClass( 'is-active' );
              }
            },
            // markers: true,
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'timeline', COMPONENT );
} )( app );
